export const TILES_IN_ROW = 4;
